var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5917 1.01212C11.5142 0.934017 11.4221 0.872021 11.3205 0.829714C11.219 0.787407 11.11 0.765625 11 0.765625C10.89 0.765625 10.7811 0.787407 10.6796 0.829714C10.578 0.872021 10.4858 0.934017 10.4084 1.01212L4.20004 7.22879L1.59171 4.61212C1.51127 4.53442 1.41632 4.47333 1.31227 4.43233C1.20823 4.39132 1.09713 4.37121 0.985308 4.37315C0.873491 4.37508 0.76315 4.39902 0.660584 4.4436C0.558019 4.48818 0.465238 4.55252 0.387539 4.63296C0.309841 4.71339 0.248746 4.80834 0.207742 4.91239C0.166739 5.01643 0.14663 5.12754 0.148565 5.23936C0.150499 5.35117 0.174439 5.46151 0.219017 5.56408C0.263595 5.66664 0.327938 5.75943 0.408373 5.83712L3.60837 9.03712C3.68584 9.11523 3.77801 9.17723 3.87956 9.21953C3.98111 9.26184 4.09003 9.28362 4.20004 9.28362C4.31005 9.28362 4.41897 9.26184 4.52052 9.21953C4.62207 9.17723 4.71424 9.11523 4.79171 9.03712L11.5917 2.23712C11.6763 2.15909 11.7438 2.06438 11.79 1.95896C11.8361 1.85355 11.86 1.73971 11.86 1.62462C11.86 1.50954 11.8361 1.3957 11.79 1.29028C11.7438 1.18487 11.6763 1.09016 11.5917 1.01212Z",
    fill: "#171720"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.76dc28f2.svg";
export { ForwardRef as ReactComponent };